import _ from 'lodash';
import { useQuery } from '@apollo/client';

import { GET_PLAYER_SCORE_SUMMARY_HISTORY } from '../queries/user-action.queries';

export const getPlayerScoreSummaryHistory = ({playerAssessmentId}: {playerAssessmentId: string}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { data, ...rest } = useQuery(GET_PLAYER_SCORE_SUMMARY_HISTORY, {
    fetchPolicy: 'cache-and-network',
    variables: { playerAssessmentId },
  });

  return { ...rest, scoreSummaryHistory: _.get(data, 'playerScoreSummaryHistory') as IUserActionScoreSummaryResult[] };
};
